import { Maybe } from 'maybe-not';
import { Change, Verb } from 'q2-tecton-common/lib/types/config';
import IDict from 'q2-tecton-common/lib/types/dict';
import SDKMessageBus from '../utility/message-bus';

export default function manageChanges(
    messageBus: SDKMessageBus,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('manageChanges')) {
        return;
    }
    function _manageChanges(verb: Verb, changes: Change[]): Promise<XMLHttpRequest>;
    function _manageChanges(changeData: IDict<Change[]>): Promise<XMLHttpRequest>;
    function _manageChanges(
        arg1: Verb | IDict<Change[]>,
        arg2?: Change[]
    ): Promise<XMLHttpRequest> {
        if (arguments.length === 1) {
            const validDataCount = Object.values(arg1 || {}).reduce(
                (acc, cur) => acc + cur.length,
                0
            );
            if (validDataCount === 0) {
                throw new Error('No valid data found to be changed');
            }
            return messageBus
                .sendRequest('manageChanges', Maybe.just({ changeData: arg1 }).map(JSON.stringify))
                .then((result: any) => {
                    return result;
                });
        } else if (arguments.length === 2) {
            if (arg2 && arg2.length === 0) {
                throw new Error('No valid data found to be changed');
            }
            return messageBus
                .sendRequest(
                    'manageChanges',
                    Maybe.just({ [arg1 as string]: arg2 }).map(JSON.stringify)
                )
                .then((result: any) => {
                    return result;
                });
        } else {
            throw new Error('manageChanges takes only 1 or 2 argument(s)');
        }
    }
    return _manageChanges;
}
